import { useEffect, useState } from "react";
import { connect } from 'react-redux';

// icn
import { getStorageInfo } from "store/services/documentStorgeService";
import { Col, Row } from "react-bootstrap";
// import StorageChart from "./Components/StorageChart";
import { useShowLoader } from "hooks/useShowLoader";
import { getFileManagerData } from "store/services/documentsService";
import CommonTable from "components/shared/CommonTable";
import { FULL_NAME, getFormattedSize } from "helpers/common";
import ReactPagination from "components/shared/ReactPagination";
import { generatePath, Link } from "react-router-dom";
import { myClientDetails } from "../../../../Routes/paths";
import FileManagerIcon from "Assets/Images/FileManagerIcon";

const FileManager = ({ dispatch, clientsListing, totalCount }) => {
  const [storageDetails, setStorageDetails] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [sortConfig, setSortConfig] = useState({
    orderBy: "total_size",
    order: "desc",
  });

  const itemsCountPerPage = 10;

  const showLoader = useShowLoader();

  useEffect(() => {
    fileManagerData(activePage);
  }, [activePage, sortConfig]);

  useEffect(() => {
    getStorageInfoData();
  }, []);

  const fileManagerData = async (page) => {
    try {
      setLoading(true);
      let params = {
        page,
        limit: itemsCountPerPage,
        orderBy: sortConfig.orderBy,
        order: sortConfig.order,
      }
      await dispatch(getFileManagerData("clientDocs", params));
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error("Error getting file manager data", err);
    }
  };

  const getStorageInfoData = async () => {
    try {
      showLoader(true);
      let response = await getStorageInfo();
      if (response?.success) {
        setStorageDetails(response?.body);
      }
      showLoader(false);
    } catch (err) {
      showLoader(false);
      console.error("Error fetching storage details", err);
    }
  };

  const handlePageChange = (page) => {
    setActivePage(page);
  }

  const columns = [
    {
      key: "id",
      label: <></>,
      component: () => {
        return (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 64 64"
              width="32"
              height="32"
            >
              <g>
                <path
                  fill="#6a6a6a"
                  d="M4.2 14v26.2c0 .6.5 1.2 1.2 1.2h52.9c.6 0 1.2-.5 1.2-1.2V14c0-.6-.5-1.2-1.2-1.2H57c-.6 0-1.2-.5-1.2-1.2V9.5c0-.6-.5-1.2-1.2-1.2H35.1c-.6 0-1.2.5-1.2 1.2v2.2c0 .6-.5 1.2-1.2 1.2H5.4c-.7-.1-1.2.4-1.2 1.1z"
                />
                <path
                  fill="#6a6a6a"
                  d="M4.2 14.8V41c0 .6.5 1.2 1.2 1.2h52.9c.6 0 1.2-.5 1.2-1.2V14.8c0-.6-.5-1.2-1.2-1.2H57c-.6 0-1.2-.5-1.2-1.2v-2.2c0-.6-.5-1.2-1.2-1.2H35.1c-.6 0-1.2.5-1.2 1.2v2.2c0 .6-.5 1.2-1.2 1.2H5.4c-.7 0-1.2.5-1.2 1.2z"
                />
                <path
                  fill="#6a6a6a"
                  d="M4.4 54.7h54.4c.6 0 1.1-.4 1.2-1l4-35.3c.1-.7-.5-1.3-1.2-1.3H1.2c-.7 0-1.2.6-1.2 1.3l3.2 35.3c.1.5.6 1 1.2 1z"
                />
                <path
                  fill="#6a6a6a"
                  d="M4.4 55.7h54.4c.6 0 1.1-.4 1.2-1l4-35.3c.1-.7-.5-1.3-1.2-1.3H1.2c-.7 0-1.2.6-1.2 1.3l3.2 35.3c.1.5.6 1 1.2 1z"
                />
              </g>
            </svg>
          </>
        )
      }
    },
    {
      key: "first_name",
      label: "Client Name",
      component: (item) => (
        <Link
          target="_blank"
          className="text-body link-underline-hover"
          to={generatePath(`${myClientDetails}?tab=Documents`, { clientId: item.client_id })}
        >
          {FULL_NAME(item?.first_name, item?.last_name)}
        </Link>
      )
    },
    {
      key: "total_documents",
      sortable: true,
    },
    {
      key: "total_size",
      sortable: true,
      component: (item) => item?.total_size
        ? getFormattedSize(item?.total_size || 0)
        : "0.00 MB"

    },
  ]

  const handleSort = (sortBy, sortOrder) => {
    setSortConfig((prev) => ({
      ...prev,
      orderBy: sortBy,
      order: sortOrder
    }))
  }

  return (
    <div className="py-2">
        <Row className="">
          <Col lg={12}>
            <div className="commonCardBox" style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px", borderRadius: "10px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px", padding: "20px 15px 2px" }}>
                <FileManagerIcon />
                <p className="text-body mb-0" style={{ fontSize: "16px", }}>File Manager</p>
              </div>
              <div className="table-responsive file-manager border-0">
                <CommonTable
                  className='bordered-table file-manager-table table-hover'
                  data={clientsListing}
                  isLoading={isLoading}
                  columns={columns}
                  sortBy={sortConfig.orderBy}
                  sortOrder={sortConfig.order}
                  onSort={handleSort}
                // indexColumn={true}
                />
              </div>
              {itemsCountPerPage < totalCount &&
                <div className="d-flex justify-content-end">
                  <ReactPagination
                    activePage={activePage}
                    itemsCountPerPage={itemsCountPerPage}
                    totalItemsCount={totalCount}
                    handlePageChange={handlePageChange}
                    showPageSizeDropdown={false}
                  // pageSizeOptions={[10, 20, 50]}
                  // onPageSizeChange={setPageSize}
                  />
                </div>
              }
            </div>
          </Col>
        </Row>
    </div>
  );
};


const mapStateToPros = (state) => {
  return {
    clientsListing: state?.Documents?.fileManagerData?.clientsListing,
    totalCount: state?.Documents?.fileManagerData?.totalCount,
  }
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToPros,
  mapDispatchToProps
)(FileManager);
